import React from 'react';
import { withTranslations, WithTranslationsProps } from 'react-utilities';
import ProofOfWork from './containers/proofOfWork';
import { ProofOfWorkContextProvider } from './store/contextProvider';
import { RequestService } from '../../../common/request';
import { TRANSLATION_CONFIG } from './app.config';
import {
  OnChallengeCompletedCallback,
  OnChallengeInvalidatedCallback,
  OnModalChallengeAbandonedCallback
} from './interface';

type Props = {
  sessionId: string;
  requestService: RequestService;
  onChallengeCompleted: OnChallengeCompletedCallback;
  onChallengeInvalidated: OnChallengeInvalidatedCallback;
  onModalChallengeAbandoned: OnModalChallengeAbandonedCallback;
} & WithTranslationsProps;

const App: React.FC<Props> = ({
  sessionId,
  requestService,
  translate,
  onChallengeCompleted,
  onChallengeInvalidated,
  onModalChallengeAbandoned
}: Props) => {
  return (
    <ProofOfWorkContextProvider
      sessionId={sessionId}
      requestService={requestService}
      onChallengeCompleted={onChallengeCompleted}
      onChallengeInvalidated={onChallengeInvalidated}
      onModalChallengeAbandoned={onModalChallengeAbandoned}>
      <ProofOfWork />
    </ProofOfWorkContextProvider>
  );
};

export default withTranslations(App, TRANSLATION_CONFIG);
